import { useEffect, useState } from "react";
import { NAV_SECTIONS } from "@/data/content";

export function useActiveSection(pathname) {
  const [active, setActive] = useState(null);

  useEffect(() => {
    const sections = NAV_SECTIONS[pathname];
    setActive(null);
    if (!sections) return;
    const hashes = sections.filter((s) => s.hash).map((s) => s.hash);
    let observer;
    const visible = new Set();

    const setup = () => {
      const els = hashes.map((h) => document.getElementById(h)).filter(Boolean);
      if (!els.length) return false;
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) visible.add(e.target.id);
            else visible.delete(e.target.id);
          });
          const current = hashes.find((h) => visible.has(h));
          if (current) setActive(current);
        },
        { rootMargin: "-42% 0px -50% 0px", threshold: 0 }
      );
      els.forEach((el) => observer.observe(el));
      return true;
    };

    if (setup()) return () => observer && observer.disconnect();
    const t = setTimeout(setup, 250);
    return () => {
      clearTimeout(t);
      if (observer) observer.disconnect();
    };
  }, [pathname]);

  return active;
}
